import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKeyOutline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillOpacity: .9,
		d: "M4.191 10.06c-.294-.294-.441-.647-.441-1.06s.147-.765.441-1.059c.294-.293.647-.44 1.059-.441.412 0 .765.147 1.06.441.294.295.44.648.44 1.06s-.146.765-.44 1.06c-.293.295-.647.442-1.06.44-.413 0-.766-.147-1.059-.44M5.25 13.5c-1.25 0-2.313-.438-3.188-1.313C1.188 11.313.75 10.25.75 9s.438-2.313 1.313-3.188C2.937 4.938 4 4.5 5.25 4.5c.837 0 1.597.206 2.278.619A4.53 4.53 0 0 1 9.15 6.75h6.6L18 9l-3.375 3.375-1.5-1.125-1.5 1.125-1.594-1.125H9.15a4.53 4.53 0 0 1-1.621 1.631A4.354 4.354 0 0 1 5.25 13.5m0-1.5c.7 0 1.316-.213 1.847-.638A3.188 3.188 0 0 0 8.156 9.75H10.5l1.088.769 1.537-1.144 1.331 1.031L15.863 9l-.75-.75H8.156A3.187 3.187 0 0 0 7.097 6.638 2.96 2.96 0 0 0 5.25 6c-.825 0-1.531.294-2.119.881A2.886 2.886 0 0 0 2.25 9c0 .825.294 1.531.881 2.119.588.587 1.294.881 2.119.881"
	})
});
export default SvgKeyOutline;
